import React, { useState, useEffect } from 'react';
import './Loader.css';

const Loader = ({ onComplete }) => {
  const [text, setText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPressEnter, setShowPressEnter] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const [codeLines, setCodeLines] = useState([]);
  const [currentCodeLine, setCurrentCodeLine] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const fullText = '> Pazzutti_';

  // Códigos fictícios para a animação
  const fakeCodes = [
    'Initializing system...',
    'Checking dependencies...',
    'Loading assets...',
    'Compiling components...',
    'Rendering interface...',
    'System ready!'
  ];

  useEffect(() => {
    // Detectar se é mobile
    const checkIfMobile = () => {
      setIsMobile(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setText(prev => prev + fullText[currentIndex]);
        setCurrentIndex(currentIndex + 1);
      }, 200);
      return () => clearTimeout(timeout);
    } else {
      const delay = setTimeout(() => {
        setShowPressEnter(true);
      }, 500);
      return () => clearTimeout(delay);
    }
  }, [currentIndex, fullText]);

  useEffect(() => {
    if (showPressEnter) {
      const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
          handleProceed();
        }
      };

      window.addEventListener('keydown', handleKeyPress);
      return () => {
        window.removeEventListener('keydown', handleKeyPress);
      };
    }
  }, [showPressEnter]);

  const handleProceed = () => {
    setShowPressEnter(false);
    setShowCode(true);
    startCodeAnimation();
  };

  const startCodeAnimation = () => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < fakeCodes.length) {
        setCodeLines(prev => [...prev, fakeCodes[i]]);
        i++;
        setCurrentCodeLine(i);
      } else {
        clearInterval(interval);
        // Aguarda 1 segundo antes de chamar onComplete
        setTimeout(() => {
          if (typeof onComplete === 'function') {
            onComplete();
          }
        }, 1000);
      }
    }, 300); // Intervalo entre linhas de código
  };

  return (
    <div className="loader-container">
      <div className="terminal">
        <div className="terminal-header">
          <div className="terminal-controls">
            <span className="control red"></span>
            <span className="control yellow"></span>
            <span className="control green"></span>
          </div>
          <div className="terminal-title">Terminal</div>
        </div>
        <div className="terminal-body">
          <div className="terminal-text">
            {text}
            {!showCode && <span className="cursor">|</span>}
          </div>
          
          {showPressEnter && (
            <>
              <div className="press-enter">
                Press enter
                <span className="blinking-cursor">|</span>
              </div>
              
              {/* Botão visível apenas em mobile */}
              {isMobile && (
                <button 
                  className="mobile-proceed-button"
                  onClick={handleProceed}
                >
                  Enter
                </button>
              )}
            </>
          )}

          {showCode && (
            <div className="code-animation">
              {codeLines.map((line, index) => (
                <div key={index} className="code-line">
                  {line}
                  {index === currentCodeLine - 1 && <span className="cursor">|</span>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Loader;